const galleryId = 15;

const items = [];

let id = galleryId * 1000;

function addItemToGroup(item, tag) {
    id++;
    items.push({
        "id": id,
        "title": { "en": "" },
        "src": item,
        "tags": [tag],
        "groups": [galleryId],
        "ordering": id,
    });
}
let group = [];

group = ["sh_532324357a.jpg","sh_1311646595.jpg","sh_1382843912.jpg","sh_1555107722.jpg","sh_1555107725.jpg","sh_1555107731.jpg","sh_1691417776.jpg","sh_1797489880.jpg","sh_327915776.jpg","sh_231350449.jpg"];
group.forEach((i) => addItemToGroup(i, '1. Impacted wisdom tooth'));

group = ["sh_1641765445.jpg","sh_1641765457.jpg","sh_1579777576.jpg"];
group.forEach((i) => addItemToGroup(i, '2. Tooth sectioning'));

group = ["sh_1710200284.jpg","sh_1710200287.jpg","sh_1710200278.jpg","sh_1710200272.jpg","sh_1710200275.jpg","sh_1710200281.jpg","sh_51320776.jpg","sh_1124399585.jpg","sh_1124399579.jpg","sh_1124399582.jpg","sh_1124399597.jpg","sh_1124399648.jpg","sh_1124399639.jpg"];
group.forEach((i) => addItemToGroup(i, '3. Cystectomy'));

group = ["sh_1490543567.jpg","sh_1442460674.jpg"];
// group.forEach((i) => addItemToGroup(i, 'x_unused'));

group = ["sh_1646434027.jpg","sh_1691417863.jpg","sh_1322268050.jpg","sh_1555107821.jpg","sh_1606945942.jpg","sh_1746929870.jpg","sh_1746929894.jpg","sh_1757139314.jpg"];
// group.forEach((i) => addItemToGroup(i, 'deleted'));

export default items;
